module.exports = __webpack_public_path__ + "static/Mahua_Roy.bbdf2882.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/Mahua_Roy.jpg
// module id = 919
// module chunks = 146520050992020